import {useBillV2, useOBPayment} from '@resurs-internal/rb-app-api';
import {createFileRoute, useNavigate} from '@tanstack/react-router';
import {PaymentCallbackSuccessPage} from 'features/shared/payment/pages';
import {useFeatureFlags} from 'hooks';
import {useEffect} from 'react';
import {useQueryClient} from '@tanstack/react-query';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/callback/_statuses/success',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const flags = useFeatureFlags();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (flags.statementSessionPayments || flags.billSessionPayments) {
      queryClient.invalidateQueries({queryKey: ['accounts', 'saved']});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {statementId} = Route.useParams();
  const search = Route.useSearch();
  const {bill} = useBillV2(statementId);
  const {query: paymentQuery} = useOBPayment(search.paymentId);

  return (
    <PaymentCallbackSuccessPage
      pageId="statement_payment_success"
      onClose={() => navigate({to: '/home/statements'})}
      payment={paymentQuery.data}
      bill={bill}
    />
  );
}
